import IntegralGoodsManagement from './integral_goods_management.vue';

export default IntegralGoodsManagement;
